






































import {Component, Vue} from 'vue-property-decorator';
import BasicInfo from '../components/BasicInfo.vue';
import Research from '../components/Research.vue';
import Publications from '../components/Publications.vue';
import Activities from '../components/Activities.vue';
import Alumnus from './Alum.vue';
import {iLabMember} from '../typings/students';
import $api from '../api';
import mockLabMember from '../mock/labMember';

@Component({
  components: {
    BasicInfo,
    Research,
    Publications,
    Activities,
    Alumnus
  }
})
export default class Home extends Vue {

  private StudentList: iLabMember[] = [];
  // private TeamMemberImages: string[] = [];

  private mounted() {
    this.getStudentList();
  };

  private getStudentList() {
    const succ = (res: any) => {
      this.StudentList = (res as any) || [];
    }
    if (this.$store.state.offModel) {
      succ(mockLabMember);
    } else {
      $api.students.findAllLabMembersClient().then(succ);
    }
  }

}
